export default "__VITE_ASSET__B4g93XJD__"